(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vk-eu27-landing"] && !Shopify.designMode) return;
  try {
    (function(){
    var t=new Date('2027-05-12T00:00:00+02:00').getTime();
    var q=function(a){return document.querySelectorAll(a);};
    var D=q('[data-vk27-dias]'),H=q('[data-vk27-h]'),M=q('[data-vk27-m]'),S=q('[data-vk27-s]');
    if(!D.length&&!H.length)return;
    var p=function(n){return(n<10?'0':'')+n;};
    var set=function(L,v){for(var i=0;i<L.length;i++)if(L[i].textContent!==String(v))L[i].textContent=v;};
    var tick=function(){
      var r=Math.max(0,Math.floor((t-Date.now())/1000));
      set(D,Math.floor(r/86400));set(H,p(Math.floor(r%86400/3600)));set(M,p(Math.floor(r%3600/60)));set(S,p(r%60));
    };
    var timer;var resume=function(){clearInterval(timer);if(!document.hidden){tick();timer=setInterval(tick,1000);}};document.addEventListener('visibilitychange',resume);resume();
  })();

  (function(){
    var tr=document.querySelector('[data-vk27-track]');if(!tr)return;
    var nav=document.querySelector('.vk27-days-nav'),pv=nav&&nav.querySelector('[data-vk27-prev]'),nx=nav&&nav.querySelector('[data-vk27-next]');
    var step=function(){var c=tr.querySelector('.vk27-dcard');return c?c.getBoundingClientRect().width+12:300;};
    var upd=function(){if(!pv)return;pv.disabled=tr.scrollLeft<4;nx.disabled=tr.scrollLeft+tr.clientWidth>=tr.scrollWidth-4;};
    if(pv){pv.addEventListener('click',function(){tr.scrollBy({left:-step(),behavior:'smooth'});});nx.addEventListener('click',function(){tr.scrollBy({left:step(),behavior:'smooth'});});}
    tr.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);upd();
    try{
      var f=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Madrid',year:'numeric',month:'2-digit',day:'2-digit'});
      var hoy=f.format(new Date()),man=f.format(new Date(Date.now()+864e5));
      tr.querySelectorAll('[data-vk27-date]').forEach(function(card){
        var d=card.getAttribute('data-vk27-date'),b=card.querySelector('[data-vk27-hoy]');
        if(d===hoy){b.textContent=nav.getAttribute('data-vk27-hoy-txt');b.hidden=false;tr.scrollLeft=card.offsetLeft-tr.offsetLeft;}
        else if(d===man){b.textContent=nav.getAttribute('data-vk27-man-txt');b.hidden=false;}
        else if(d<hoy){card.classList.add('is-past');}
      });upd();
    }catch(e){}
    var cards=[].slice.call(tr.querySelectorAll('.vk27-dcard')),cur=null;
    var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
    var names=function(on){cards.forEach(function(c,i){c.style.viewTransitionName=on?'vk27-d'+(i+1):'';});};
    var vt=function(fn,after){
      if(!document.startViewTransition||rm){fn();if(after)after();return;}
      names(true);var t=document.startViewTransition(fn);
      var end=function(){names(false);if(after)after();};t.finished.then(end,end);
    };
    var hash=function(h){try{history.replaceState(null,'',h||location.pathname+location.search);}catch(e){}};
    var into=function(c){var r=c.getBoundingClientRect(),off=110;if(r.top<off||r.top>innerHeight*.45)window.scrollTo({top:window.pageYOffset+r.top-off,behavior:rm?'auto':'smooth'});};
    var set=function(c,on){c.classList.toggle('is-open',on);c.querySelector('[data-vk27-open]').setAttribute('aria-expanded',on?'true':'false');};
    var open=function(c){
      if(!c||c===cur)return;
      vt(function(){if(cur)set(cur,false);cur=c;set(c,true);tr.classList.add('is-open');},
         function(){into(c);c.querySelector('[data-vk27-close]').focus({preventScroll:true});hash('#'+c.id);});
    };
    var shut=function(anim){
      var c=cur;if(!c)return;
      var fn=function(){set(c,false);tr.classList.remove('is-open');cur=null;tr.scrollLeft=c.offsetLeft-tr.offsetLeft;upd();};
      hash();
      if(!anim){fn();return;}
      vt(fn,function(){into(c);c.querySelector('[data-vk27-open]').focus({preventScroll:true});});
    };
    tr.addEventListener('click',function(ev){
      var t=ev.target;
      if(t.closest('[data-vk27-open]')){open(t.closest('.vk27-dcard'));return;}
      if(t.closest('[data-vk27-close]')){shut(true);return;}
      var st=t.closest('[data-vk27-step]');if(st&&cur){open(cards[cards.indexOf(cur)+(+st.getAttribute('data-vk27-step'))]);return;}
      if(t.closest('[data-vk27-go]'))shut(false);
    });
    document.addEventListener('keydown',function(ev){if(ev.key==='Escape'&&cur)shut(true);});
    var m=/^#dia-1[2-6]$/.exec(location.hash);
    if(m){var c0=document.getElementById(location.hash.slice(1));if(c0){cur=c0;set(c0,true);tr.classList.add('is-open');setTimeout(function(){into(c0);},60);}}
  })();
  } catch(e) { console.error(e); }
})();

})();
